export default "__VITE_ASSET__5bfb1364__"